import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StoreSelectionDialogComponent } from './dialogs/store-selection-dialog.component';
import { DashboardService } from './dashboard.service';
import { ConfirmDialogComponent } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-hq-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss', '../dashboard.scss'],
    standalone: false
})

export class HqDashboardComponent implements OnInit {

    dashboardData: any;
    displayData: any;
    salesForcastAnnual: any;
    salesForcastWeekly: any;

    isLoading: boolean = true;
    GST_VALUE: any;
    targetImg: any;
    selectedShopName: string | null = null;
    selectedShopId: string | null = null;
    lastUpdatedMsg: string = '';
    userData: any;
    selectedStoreIds: any = [];
    includeSameStoreLY: any;
    selectedStoresNames: any;
    selectedStoreIdsAll: number[] = [];
    selectedStoreIdsSushi: number[] = [];
    selectedStoreIdsBento: number[] = [];
    lastTabIndex: number = 0;
    allStores: any;
    sushiStores: any;
    bentoStores: any;
    constructor(private dashboardService: DashboardService, private dialog: MatDialog) { }

    ngOnInit(): void {
        const userDetailsData = sessionStorage.getItem('user');
        if (userDetailsData) {
            this.userData = JSON.parse(userDetailsData);
        }
        this.loadData();
    }

    buildParams(params?: any): any {
        // Default structure
        let payload: any = { shop_ids: [], refresh_data: '' };

        // Merge incoming params
        if (params) {
            if (params.shop_ids) payload.shop_ids = params.shop_ids;
            if (params.refresh_data !== undefined) payload.refresh_data = params.refresh_data;
            if (params.$multipleShop) payload.$multipleShop = params.$multipleShop;
            // Add other keys as needed
        }

        // If AREA_MANAGER and shop_ids is empty, use user_shops (array of objects)
        if (this.userData?.user_type === 'AREA_MANAGER' && Array.isArray(payload.shop_ids) && payload.shop_ids.length === 0) {
            if (Array.isArray(this.userData.user_shops)) {
                payload.shop_ids = this.userData.user_shops.map((shop: any) => shop.id);
            }
        }

        return payload;
    }

    loadData(params?: any) {
        this.isLoading = true;
        const payload = this.buildParams(params);
        this.dashboardService.getDashboardData(payload).subscribe({
            next: (response) => {
                this.dashboardData = response.data;
                this.isLoading = false;
                // Populate global store arrays
                let allShops = this.dashboardData?.all_shops || [];
                if (this.userData?.user_type === 'AREA_MANAGER' && Array.isArray(this.userData.user_shops)) {
                    const userShopIds = this.userData.user_shops.map((shop: any) => Number(shop.id));
                    allShops = allShops.filter((s: any) => userShopIds.includes(Number(s.id)));
                }
                this.allStores = allShops.filter((s: any) => s.shop_type !== 'DT');
                this.sushiStores = this.allStores.filter((s: any) => s.shop_type === 'SUSHI');
                this.bentoStores = this.allStores.filter((s: any) => s.shop_type === 'BENTO');
                // -------Forecast Section-------
                const forcastPercentageAdjustmentAnnual = (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual ?? 0) * this.dashboardData?.sale_forcast_percentage) / 100);
                this.salesForcastAnnual = this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual + forcastPercentageAdjustmentAnnual;
                const forcastPercentageAdjustmentWeekly = (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly ?? 0) * this.dashboardData?.sale_forcast_percentage) / 100);
                this.salesForcastWeekly = this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly + forcastPercentageAdjustmentWeekly;
                // Set last updated message
                const timeDiff = this.dashboardData?.last_updated_diff;
                if (timeDiff < 1) {
                    this.lastUpdatedMsg = 'Last updated less than 1 min ago';
                } else {
                    this.lastUpdatedMsg = 'Last updated at ' + timeDiff + ' min ago';
                }
            },
            error: (err) => {
                this.isLoading = false;
                console.error('Dashboard API error', err);
            }
        });
    }

    onDashboardDataChange(newData: any) {
        this.dashboardData = newData;
        this.selectedShopName = newData.selectedShopName || null;
        this.selectedShopId = newData.selectedShopId || null;

        // Recalculate forecasts
        const forcastPercentageAdjustmentAnnual =
            (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual ?? 0) *
                this.dashboardData?.sale_forcast_percentage) /
                100);
        this.salesForcastAnnual =
            this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual +
            forcastPercentageAdjustmentAnnual;

        const forcastPercentageAdjustmentWeekly =
            (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly ?? 0) *
                this.dashboardData?.sale_forcast_percentage) /
                100);
        this.salesForcastWeekly =
            this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly +
            forcastPercentageAdjustmentWeekly;

        // Set selected shop name if present in newData
        if (newData?.selectedShopName) {
            this.selectedShopName = newData.selectedShopName;
        } else {
            this.selectedShopName = null;
        }
    }
    onBackToHQDashboard() {
        this.selectedShopId = null;
        this.selectedShopName = null;
        this.loadData();
    }
    onShopSelected(store: any) {
        this.selectedShopId = store.shopId;
        this.selectedShopName = store.name;
        // For single shop selection, use shop_id: [id]
        this.loadData({ shop_ids: [store.shopId], refresh_data: '' });

    }

    openStoreSelectionDialog() {
        let storesToShow = this.dashboardData?.all_shops || [];
        // If AREA_MANAGER, filter to only user_shops (array of objects), ensure type consistency and correct property
        if (this.userData?.user_type === 'AREA_MANAGER' && Array.isArray(this.userData.user_shops)) {
            const userShopIds = this.userData.user_shops.map((shop: any) => Number(shop.id));
            storesToShow = storesToShow.filter((s: any) => userShopIds.includes(Number(s.id)));
        }
        const dialogRef = this.dialog.open(StoreSelectionDialogComponent, {
            width: '480px',
            minWidth: '330px',
            minHeight: '420px',
            data: {
                selectedStoreIds: this.selectedStoreIds,
                allStores: this.allStores,
                sushiStores: this.sushiStores,
                bentoStores: this.bentoStores,
                lastYearSameWeekStoreInfo: this.dashboardData?.last_year_same_week_store_info || {},
                includeSameStoreLY: this.includeSameStoreLY,
                tabIndex: this.lastTabIndex
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.selectedStoreIds) {
                const allStores = this.dashboardData?.all_shops || [];
                this.lastTabIndex = result.tabIndex || 0;
                this.includeSameStoreLY = !!result.includeSameStoreLY;
                this.selectedStoreIds = result.selectedStoreIds;
                // let shopIds = this.selectedStoreIds.map((s: any) => s.id);
                if (this.selectedStoreIds && this.selectedStoreIds.length > 0) {
                    this.selectedStoresNames = allStores
                        .filter((store: any) => this.selectedStoreIds.includes(store.id))
                        .map((store: any) => store.name)
                        .join(', ');
                } else {
                    this.selectedStoresNames = 'ALL STORES';
                }
                let payload: any = { refresh_data: '' };
                if (this.selectedStoreIds.length === allStores.length) {
                    payload.shop_ids = [];
                } else {
                    payload.shop_ids = this.selectedStoreIds;
                    payload.$multipleShop = (this.selectedStoreIds.length > 1);
                }
                this.loadData(payload);
            }
        });
    }

    onRefresh() {
        const dialogRef = this.dialog.open(
            ConfirmDialogComponent,
            {
                width: '350px',
                data: {
                    title: 'Confirm Refresh',
                    message: "This may take few minutes to refresh all shop's data. Do you want to continue?",
                    yesButtonCaption: 'Yes',
                    noButtonCaption: 'Cancel',
                    showNoButton: true
                }
            }
        );
        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.loadData({ shop_ids: [], refresh_data: 1 });
            }
        });
    }

    printDashboard() {
        window.print();
    }
}

